import "vuetify/styles";
import { createVuetify, type ThemeDefinition } from "vuetify";
import { md3 } from "vuetify/blueprints";
import { aliases, mdi as mdiIcons } from "vuetify/iconsets/mdi-svg";

import { appConfig } from "#config/app";

// Theme colors generated at: https://m3.material.io/theme-builder

const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: "#b0cadb",
    "on-primary": "#1a3340",
    secondary: "#bec8cf",
    "on-secondary": "#283237",
    tertiary: "#d5bfdc",
    "on-tertiary": "#3a2b41",
    background: "#191c1d",
    "on-background": "#e0e3e3",
    error: "#ffb4ab",
    "on-error": "#690005",
    // surface: "#191c1d", // original
    surface: "#2a2f31",
    // "on-surface": "#e0e3e3", // original
    "on-surface": "#e2e5e5",
  },
};

const lightTheme: ThemeDefinition = {
  dark: false,
  // Used some container colors instead of non-container ones
  colors: {
    primary: "#445d6b",
    "on-primary": "#ffffff",
    secondary: "#dae4eb",
    "on-secondary": "#ffffff",
    tertiary: "#65546c",
    "on-tertiary": "#ffffff",
    background: "#f6fcfc",
    "on-background": "#191c1d",
    error: "#ba1a1a",
    "on-error": "#ffffff",
    info: "#4a8ad6",
    // info: "#2196f3", // original
    surface: "#fefefe",
    // surface: "#fafdfd", // original
    "on-surface": "#060707",
    // "on-surface": "#191c1d", // original
  },
};

export const vuetifyPlugin = createVuetify({
  blueprint: md3,
  defaults: {
    VAlert: {
      variant: "tonal",
    },
    VCheckbox: {
      color: "primary",
      persistentHint: true,
    },
    VDataTable: {
      itemsPerPage: appConfig.development ? 10 : 50,
      itemsPerPageOptions: appConfig.development ? [1, 2, 5, 10, 25, 50, 100] : undefined,
    },
    VDateInput: {
      color: "primary",
      persistentHint: true,
    },
    VDataTableServer: {
      itemsPerPage: appConfig.development ? 10 : 50,
      itemsPerPageOptions: appConfig.development ? [1, 2, 5, 10, 25, 50, 100] : undefined,
    },
    VFileInput: {
      persistentHint: true,
    },
    VPagination: {
      density: "compact",
      totalVisible: 5,
    },
    VProgressCircular: {
      color: "primary",
    },
    VSelect: {
      color: "primary",
      persistentHint: true,
    },
    VSwitch: {
      color: "primary",
      inset: true,
      persistentHint: true,
      style: "--v-input-control-height: unset;",
    },
    VTextField: {
      color: "primary",
      persistentHint: true,
    },
    VTextarea: {
      color: "primary",
      persistentHint: true,
    },
    VTooltip: {
      location: "bottom center",
      openDelay: 250,
    },
  },
  display: {
    mobileBreakpoint: "md",
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi: mdiIcons },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      dark: darkTheme,
      light: lightTheme,
    },
    variations: {
      colors: ["primary", "secondary", "tertiary", "error", "warning"],
      lighten: 2,
      darken: 2,
    },
  },
  // TODO: Consider changing if SSR is ever supported (or fixed) at Nuxt project level
  ssr: false,
});
